<nav class="di-nav">
  <ul>
    <li *ngFor="let item of menu_items">
      <a *ngIf="item.menu_link" class="nav-item"
        [ngClass]="{'active': isMenuActive(item)}"
        [routerLink]="item.menu_link">
        {{ item.menu_name }}
        <ng-container *ngIf="!item.menu_link">
          <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 0H0L4 4.5L8 0Z" fill="#9D9D9D" />
          </svg>
        </ng-container>
      </a>
      <a *ngIf="!item.menu_link" href="javascript:void(0)" class="nav-item has-sub-menu"
        [ngClass]="{'active': isMenuActive(item)}">
        {{ item.menu_name }}
        <ng-container *ngIf="!item.menu_link">
          <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 0H0L4 4.5L8 0Z" fill="#9D9D9D" />
          </svg>
        </ng-container>
      </a>
      <div class="sub-menu" *ngIf="item.sub_menu">
        <ul>
          <li *ngFor="let submenu of item.sub_menu">
            <ng-container *ngIf="submenu.url">
              <a [routerLink]="submenu.url" [routerLinkActive]="['active']" [innerHTML]="submenu.name"></a>
            </ng-container>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</nav>